import { ChangeEvent } from 'react';
import { useNavigate } from 'react-router';
import logo from '../../assets/icons/alpha_taxis_logo.svg';
import Button from '../../common/Button/Button';
import Input from '../../common/Input/Input';
import Text from '../../common/Text/Text';
import useBooking from '../../hooks/useBooking/useBooking';
import useHotelConfig from '../../hooks/useHotelConfig/useHotelConfig';
import { submitBooking } from '../../utils/booking/booking';
import isValidEmail from '../../utils/email/email';
import './Email.scss';

const Email = () => {
  const { email, setEmail, booking } = useBooking();
  const { hotelConfiguration } = useHotelConfig();
  const navigate = useNavigate();

  const handleEmailChange = (e: ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const handleContinue = () => {
    submitBooking(booking, hotelConfiguration)
      .then(
        res =>
          navigate('/booking-confirmation', {
            state: { price: res?.data?.jobs?.[0]?.fareEstimate?.grossAmountCents },
          }) as void,
      )
      .catch(console.error);
  };

  return (
    <div className="email">
      <img src={logo} className="logo" />
      <div className="content">
        <Text type="header">Add email for receipt</Text>
        <Input inputId="email" onChange={handleEmailChange} value={email} inputType="email" />
        <Button
          buttonStyleType="primary"
          label="Continue"
          handleClick={handleContinue}
          customStyling={{ width: '100%' }}
          disabled={!isValidEmail(email)}
        />
      </div>
    </div>
  );
};

export default Email;
